import { AccordionContainer } from "../../../../../../common/components/accordion/accordion.module";
import { InputContainer } from "../../../../../../common/components/form/input/containers/input.container";


export default function DodProgramParticipantBasicInfoComponent({ selectedDODProgramParticipant, handleInnerFormChange }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              labelField="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                );
              }}
              type="text"
              value={selectedDODProgramParticipant?.Name}
            />
             <InputContainer
              label="Global DODProgram Participant Code"
              labelField="GlobalDODProgramParticipantCode"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'GlobalDODProgramParticipantCode',

                );
              }}
              type="text"
              value={selectedDODProgramParticipant?.GlobalDODProgramParticipantCode}
            />
                  <InputContainer
              label="Active"
              labelField="IsActive"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsActive',

                );
              }}
              type="checkbox"
              value={selectedDODProgramParticipant?.IsActive}
            />
 <div className='col-span-full'>
              <InputContainer
            
                          label="Description"
                          name="Description"
                          onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'Description',

                              );
                            }}
                          type="rte"
                          value={selectedDODProgramParticipant?.Description}
                        /></div>
          </div>

        }
        expandedPanel="basicInfo"
        headerTitle="Basic Information"
      />

    </>
  )
}